import "./App.css";
import { Route, Routes } from "react-router-dom";
import { ConfigProvider, App as AntdApp } from "antd";
import ThemeObj from "./theme";
import Login from "./loginadmin/login";
import HomePage from "./websiteCode/indexpage";
import AdminNavigation from "./adminnavigation";
import Loginclient from "./loginclient/loginclient";
import ClientNavigation from "./clientnavigation";
import ViewProductDetails from "./websiteCode/productmanagement/viewProductDetails";
import ProductMainpage from "./websiteCode/productmanagement/productMainPage";
import Bookingproduct from "./websiteCode/bookingprductpage/bookingproduct";
import Contactpage from "./websiteCode/contactpage/contactpage";
import Aboutpageweb from "./websiteCode/aboutpage/aboutpageweb";
import Categoryviewpage from "./websiteCode/categoryManagement/categoryviewpage";
import SubcategoryView from "./websiteCode/categoryManagement/subcategory/subcategoryView";
import Videomanagement from "./websiteCode/videoManagement/videomanagement";
import Cart from "./websiteCode/bookingprductpage/cart/cart";

function App() {
  return (
    <ConfigProvider theme={ThemeObj}>
      <AntdApp>
        <Routes>
          <Route path="/admin" element={<Login />} />
          <Route path="/client" element={<Loginclient />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/Contact" element={<Contactpage />} />
          <Route path="/about" element={<Aboutpageweb />} />
          <Route path="/product" element={<ProductMainpage />} />
          <Route path="/video" element={<Videomanagement />} />
          <Route path="/cart/:id" element={<Cart />} />

          <Route path="/book-now/:id" element={<Bookingproduct />} />
          <Route path="/product/:id" element={<ViewProductDetails />} />
          <Route path="/category/:id" element={<Categoryviewpage />} />
          <Route path="/subCategory/:id" element={<SubcategoryView />} />
          <Route path="/admin/*" element={<AdminNavigation />} />
          <Route path="/client/*" element={<ClientNavigation />} />
        </Routes>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;
